(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tortli-tee-price"] && !Shopify.designMode) return;
  try {
    (() => {
  const parsePrice = (text) => {
    const normalized = String(text || '')
      .replace(/\s/g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '');
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const storefrontLocale = document.documentElement.lang || 'pl-PL';

  const formatMoney = (value) =>
    new Intl.NumberFormat(storefrontLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);

  const getCurrencyLabel = (text) =>
    String(text || '').match(/(?:Kč|zł|€|Ft|lei|£|GBP|RON|CZK|PLN|HUF)/i)?.[0] || '';

  const correctCurrency = (element) => {
    if (!element) return;
    const corrected = element.textContent.replace(/\bzl\b/gi, 'zł');
    if (corrected !== element.textContent) element.textContent = corrected;
  };

  const updateCard = (card) => {
    const currentElement = card.querySelector('.tee-price--current');
    const compareElement = card.querySelector('.tee-price--compare');
    if (!currentElement) return;

    correctCurrency(currentElement);
    correctCurrency(compareElement);

    const current = parsePrice(currentElement.textContent);
    const compare = compareElement ? parsePrice(compareElement.textContent) : null;
    const hasDiscount = current !== null && compare !== null && compare > current;

    card.classList.toggle('tortli-price-card', hasDiscount);
    card.classList.toggle('tortli-price-regular', !hasDiscount && current !== null);

    let badge = card.querySelector('.tortli-price-card__badge');
    let saving = card.querySelector('.tortli-price-card__saving');

    if (!hasDiscount) {
      badge?.remove();
      saving?.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'tortli-price-card__badge';
      badge.setAttribute('aria-label', document.querySelector('[data-tortli-price-labels]')?.dataset.discountLabel || '');
      card.append(badge);
    }

    if (!saving) {
      saving = document.createElement('p');
      saving.className = 'tortli-price-card__saving';
      card.append(saving);
    }

    const badgeText = `-${Math.round(((compare - current) / compare) * 100)}%`;
    const currencyLabel = getCurrencyLabel(currentElement.textContent);
    const savingLabel = document.querySelector('[data-tortli-price-labels]')?.dataset.savingsLabel || '';
    const savingText = `${savingLabel} ${formatMoney(compare - current)}${currencyLabel ? ` ${currencyLabel}` : ''}`;

    if (badge.textContent !== badgeText) badge.textContent = badgeText;
    if (saving.textContent !== savingText) saving.textContent = savingText;
  };

  const updateAll = () => {
    document.querySelectorAll('.product__info-container').forEach((container) => {
      container.classList.toggle(
        'tortli-has-tee-price',
        Boolean(container.querySelector('.tee-price-wrapper'))
      );
    });
    document.querySelectorAll('.tee-campaign .tee-product-price').forEach(updateCard);
  };

  let scheduled = false;
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  };

  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
